import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

interface KeyValueEditorOptions {
	header: string;
	buttonText: string;
}

@Component({
	selector: 'app-keyvalue-editor-dialog',
	templateUrl: './keyvalue-editor-dialog.component.html',
	styleUrls: ['./keyvalue-editor-dialog.component.scss'],
	standalone: false,
})
export class KeyValueEditorDialogComponent {
	public header: string = '';
	public buttonText: string = '';

	public key: string = '';
	public value: string = '';

	constructor(
		public dialogRef: MatDialogRef<KeyValueEditorDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: KeyValueEditorOptions,
		private translate: TranslateService
	) {
		this.header = data.header ?? this.translate.instant('dialogs.keyValueEditor.title');
		this.buttonText = data.buttonText ?? this.translate.instant('common.confirm');
	}

	public update() {
		if (this.key && this.value) {
			const result: { [key: string]: string } = {};
			result[this.key] = this.value;
			this.dialogRef.close(result);
		}
	}
}
